module.exports = __webpack_public_path__ + "img/1944-Pauli Murray.80bc9fa4.png";